import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pages: [
      {
        id: 1,
        title: "Eisenhower matrix",
        description_link: "/eisen/about",
        maxIndex: 10,
        sections: [
          {
            id: 1,
            name: "Important | Urgent",
            color: "#009134",
          },
          {
            id: 2,
            name: "Important | Not Urgent",
            color: "#388bf2",
          },
          {
            id: 3,
            name: "Not Important | Urgent",
            color: "#fc8338",
          },
          {
            id: 4,
            name: "Not Important | Not Urgent",
            color: "#ef2a34",
          },
        ],
        todos: [],
      },
      {
        id: 2,
        title: "S.W.O.T Analysis",
        description_link: "/swot/about",
        maxIndex: 10,
        sections: [
          {
            id: 1,
            name: "Strength",
            color: "#009134",
          },
          {
            id: 2,
            name: "Weakness",
            color: "#388bf2",
          },
          {
            id: 3,
            name: "Opportunity",
            color: "#fc8338",
          },
          {
            id: 4,
            name: "Threat",
            color: "#ef2a34",
          },
        ],
        todos: [],
      },
      {
        id: 3,
        title: "Ikigai",
        description_link: "/ikigai/about",
        maxIndex: 10,
        sections: [
          {
            id: 1,
            name: "What you love",
            color: "#009134",
          },
          {
            id: 2,
            name: "Mission",
            color: "#388bf2",
          },
          {
            id: 3,
            name: "What the world needs",
            color: "#fc8338",
          },
          {
            id: 4,
            name: "Passion",
            color: "#ef2a34",
          },
          {
            id: 5,
            name: "Ikigai",
            color: "#009134",
          },
          {
            id: 6,
            name: "Vocation",
            color: "#ef2a34",
          },
          {
            id: 7,
            name: "What you are good at",
            color: "#fc8338",
          },
          {
            id: 8,
            name: "Profession",
            color: "#388bf2",
          },
          {
            id: 9,
            name: "What you can be paid for",
            color: "#009134",
          },
        ],
        todos: [],
      },
      {
        id: 4,
        title: "MoSCoW",
        description_link: "/moscow/about",
        maxIndex: 10,
        sections: [
          {
            id: 1,
            name: "Must Have",
            color: "#009134",
          },
          {
            id: 2,
            name: "Should Have",
            color: "#388bf2",
          },
          {
            id: 3,
            name: "Could Have",
            color: "#fc8338",
          },
          {
            id: 4,
            name: "Won't Have",
            color: "#ef2a34",
          },
        ],
        todos: [],
      },
      {
        id: 5,
        title: "R.I.C.E",
        description_link: "/rice/about",
        maxIndex: 10,
        sections: [
          {
            id: 1,
            name: "Reach",
            color: "#009134",
          },
          {
            id: 2,
            name: "Impact",
            color: "#388bf2",
          },
          {
            id: 3,
            name: "Confidence",
            color: "#fc8338",
          },
          {
            id: 4,
            name: "Effort",
            color: "#ef2a34",
          },
        ],
        todos: [],
      },
      {
        id: 6,
        title: "Pros & Cons",
        description_link: "/procon/about",
        maxIndex: 10,
        sections: [
          {
            id: 1,
            name: "Pros",
            color: "#009134",
          },
          {
            id: 2,
            name: "Cons",
            color: "#ef2a34",
          },
        ],
        todos: [],
      },
      {
        id: 7,
        title: "S.M.A.R.T",
        description_link: "/smart/about",
        maxIndex: 10,
        sections: [
          {
            id: 1,
            name: "Specific",
            color: "#009134",
          },
          {
            id: 2,
            name: "Measurable",
            color: "#388bf2",
          },
          {
            id: 3,
            name: "Assignable",
            color: "#fc8338",
          },
          {
            id: 4,
            name: "Realistic",
            color: "#3f1723",
          },
          {
            id: 5,
            name: "Timely",
            color: "#ef2a34",
          },
        ],
        todos: [],
      },
      {
        id: 8,
        title: "Kanban",
        description_link: "/kanban/about",
        maxIndex: 10,
        sections: [
          {
            id: 1,
            name: "Todo",
            color: "#ef2a34",
          },
          {
            id: 2,
            name: "Doing",
            color: "#388bf2",
          },
          {
            id: 3,
            name: "Done",
            color: "#009134",
          },
        ],
        todos: [],
      },
      {
        id: 9,
        title: "Product Vision",
        description_link: "/product-vision/about",
        maxIndex: 10,
        sections: [
          {
            id: 1,
            name: "Target Group",
            color: "#009134",
          },
          {
            id: 2,
            name: "Needs",
            color: "#388bf2",
          },
          {
            id: 3,
            name: "Product",
            color: "#fc8338",
          },
          {
            id: 4,
            name: "Business Board",
            color: "#ef2a34",
          },
        ],
        todos: [],
      },
      {
        id: 10,
        title: "S.P.A.D.E",
        description_link: "/spade/about",
        maxIndex: 10,
        sections: [
          {
            id: 1,
            name: "Setting",
            color: "#009134",
          },
          {
            id: 2,
            name: "People",
            color: "#388bf2",
          },
          {
            id: 3,
            name: "Alternatives",
            color: "#fc8338",
          },
          {
            id: 4,
            name: "Decide",
            color: "#3f1723",
          },
          {
            id: 5,
            name: "Explain",
            color: "#ef2a34",
          },
        ],
        todos: [],
      },
      {
        id: 11,
        title: "D.A.C.I.",
        description_link: "/daci/about",
        maxIndex: 10,
        sections: [
          {
            id: 1,
            name: "Driver",
            color: "#009134",
          },
          {
            id: 2,
            name: "Approver",
            color: "#388bf2",
          },
          {
            id: 3,
            name: "Contributor",
            color: "#fc8338",
          },
          {
            id: 4,
            name: "Informed",
            color: "#ef2a34",
          },
        ],
        todos: [],
      },
    ],
  },
  mutations: {
    addOrUpdateTodo(state, obj) {
      let isPresent = false;
      let page = state.pages.filter((page) => {
        return page.id == obj.pageID;
      })[0];
      let todos = [];
      for (var ind = 0; ind < page.todos.length; ind++) {
        if (page.todos[ind].todoID == obj.todo.todoID) {
          todos.push(obj.todo);
          isPresent = true;
        } else {
          todos.push(page.todos[ind]);
        }
      }
      page.todos = todos;
      if (!isPresent) {
        page.todos.push(obj.todo);
      }
      for (var ind = 0; ind < state.pages; ind++) {
        if (state.pages[ind].id == pageID) {
          state.pages[ind] = page;
        }
      }
    },
    deleteTodo(state, obj) {
      let page = state.pages.filter((page) => {
        return page.id == obj.pageID;
      })[0];
      let newTodos = [];
      for (var ind = 0; ind < page.todos.length; ind++) {
        if (page.todos[ind].todoID != obj.todo.todoID) {
          newTodos.push(page.todos[ind]);
        }
      }
      page.todos = newTodos;
      for (var ind = 0; ind < state.pages.todos; ind++) {
        if (state.pages.todos[ind].id == pageID) {
          state.pages[ind] = page;
        }
      }
    },
    incrementMaxIndex(state, obj) {
      let page = state.pages.filter((page) => {
        return page.id == obj.pageID;
      })[0];
      page.maxIndex = obj.maxIndex;
      for (var ind = 0; ind < state.pages; ind++) {
        if (state.pages[ind].id == pageID) {
          state.pages[ind] = page;
        }
      }
    },
  },
  getters: {
    page: (state) => (pageID) => {
      return state.pages.filter((page) => {
        return page.id == pageID;
      });
    },
    maxIndex: (state) => (pageID) => {
      let page = state.pages.filter((page) => {
        return page.id == pageID;
      });
      return page[0].maxIndex;
    },
    getTodosBySectionID: (state) => (pageID, sectionID) => {
      let page = state.pages.filter((page) => {
        return page.id == pageID;
      });
      return page[0].todos.filter((todo) => {
        return todo.sectionID == sectionID;
      });
    },
    todo: (state) => (pageID, todoID) => {
      let page = state.pages.filter((page) => {
        return page.id == pageID;
      });
      let todo = page[0].todos.filter((todo) => {
        return todo.todoID == todoID;
      });
      return todo[0];
    },
    getSectionByID: (state) => (pageID, sectionID) => {
      let page = state.pages.filter((page) => {
        return page.id == pageID;
      });
      return page[0].sections.filter((section) => {
        return section.id == sectionID;
      });
    },
  },
  actions: {},
  modules: {},
});
